import DoubleBarChart from '@components/design/migrated/DoubleBarChart/DoubleBarChart';
import { GrowthTypes } from '@components/comparison-growth-selector/Types';

import { LeaderboardKpi } from '@models/Products';
import { getProductsChartOptions } from './ProductsChartConfig';
import { FactRevenue } from '@utils/pageConfig/Types';
import React from 'react';
import { useSelector } from 'react-redux';
import { IRootState } from '@state/reducers/Reducers';
import { isPeriodYTDOrMAT } from '@utils/PeriodUtils';
import { Dimensions, OnExportReadyCallback } from '@ecosystem/export-utils';
import { ChartScales } from '@data-visualization/performance-segment-mulitple-chart/hooks/UsePerformanceSegmentMultipleChartScales';
import { KpiDropdownOption } from '@data-visualization/performance-segment-chart/Types';
import { useInitDoubleBarChart } from '@data-visualization/products-leaderboard-bar-chart/useInitDoubleBarChart';

interface Props {
  topSellingProductsContent: LeaderboardKpi[];
  selectedGrowthType: GrowthTypes;
  factRevenue: FactRevenue;
  onExportReady: OnExportReadyCallback;
  chartScales?: ChartScales;
  dimensions?: Dimensions;
  index?: number;
  selectedKpi: KpiDropdownOption;
}

export const ProductsLeaderboardBarChart: React.FC<Props> = ({
  topSellingProductsContent,
  selectedGrowthType,
  factRevenue,
  selectedKpi,
  onExportReady,
  chartScales,
  dimensions,
  index,
}): JSX.Element => {
  const { period } = useSelector((state: IRootState) => state.mainFiltersProducts);

  const chartOptions = getProductsChartOptions({
    kpiKey: selectedKpi.value,
    kpiLabel: selectedKpi.label,
    selectedGrowthType,
    products: topSellingProductsContent,
    factRevenue,
    isHideChangeLabels: isPeriodYTDOrMAT(period),
  });

  const { options, chartCallback } = useInitDoubleBarChart({
    chartOptions,
    chartScales,
    index,
    onExportReady,
    dimensions,
  });

  return (
    <div data-testid="products-bar-chart">
      <DoubleBarChart options={options} callback={chartCallback} />
    </div>
  );
};
